<div>
    <span>{{ dateList[index] | date:'dd/MM/yyyy' }}</span>
</div>
<div>
    <div class="item">
        <span>{{ obsList[index] ? (obsList[index] | number: '1.2-2') : 'Pas de donnée' }}</span>
    </div>
    <div class="item">
        <span>{{ iahrList[index] ? (iahrList[index] | number: '1.2-2') : 'Pas de donnée' }}</span>
    </div>
</div>